import axios from 'axios';
import { decompressData } from '/src/utils/decompressData';

export const fetchQGDData = async (property) => {
    // console.log(property);
    try {
        const response = await axios.post(
            `${import.meta.env.VITE_API_BASE_URL}/get-zip-fips-state`,
            {
                zip: property.zip_code,
                fips: property.fips,
                state: property.state_short_name
            }
        );

        if (response.data) {
            // Return decompressed data without touching localStorage
            return {
                zip: response.data.zip ? {
                    [property.zip_code]: decompressData(response.data.zip)
                } : {},
                fips: response.data.fips ? {
                    [property.fips]: decompressData(response.data.fips)
                } : {},
                state: response.data.state ? {
                    [property.state_short_name]: decompressData(response.data.state)
                } : {}
            };
        }
        return null;
    } catch (error) {
        console.error('Error fetching QGD data:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        }
        throw error;
    }
};
